import React from "react";
import { Link } from "react-router-dom";
import styled from "@emotion/styled";

import typography from "../../util/typography";
import { colors } from "../../util/consts";


export default class IframeInvalidSession extends React.Component {
  render() {
    return (
      <Container>
        <Info>
          <Heading>Invalid session!</Heading>
          <SubHeading>We're sorry, seems that your session is invalid. Please logout and login again.</SubHeading>
          <Code>Error code: 401</Code>
        </Info>
      </Container>
    );
  }
}

const Container = styled.div`
  width: 100%;
  min-height: calc(100vh - 96px);
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
`;

const Info = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;

  @media (max-width: 899px) {
    flex: 1 0 300px;
    padding: 0 30px;
  }
  @media (min-width: 900px) {
    max-width: 430px;
  }
`;

const Heading = styled.h1`
  ${typography.heading2};
  color: ${colors.primary.main};
`;

const SubHeading = styled.h2`
  ${typography.heading5};
  color: ${colors.primary.main};
  margin-top: 17px;
`;

const Code = styled.h2`
  ${typography.subtitle1};
  color: ${colors.primary.main};
  opacity: 0.6;
  margin-top: 17px;
`;
